/**
 * Extracts hostname from a URL string.
 * Handles URLs with or without protocol prefix.
 */
export function getHostname(url: string): string {
  if (!url) return ""
  try {
    const urlString = url.startsWith("http") ? url : `https://${url}`
    return new URL(urlString).hostname
  } catch {
    return url
  }
}

/**
 * Ensures URL has https:// protocol prefix.
 * If URL already has protocol, returns as-is.
 */
export function getFullUrl(url: string): string {
  if (!url) return ""
  return url.startsWith("http") ? url : `https://${url}`
}
